import { render, staticRenderFns } from "./incidentReportUnableToWorkDays.vue?vue&type=template&id=3fa623e2"
import script from "./incidentReportUnableToWorkDays.vue?vue&type=script&lang=js"
export * from "./incidentReportUnableToWorkDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports